module.exports = __webpack_public_path__ + "static/logo-supporters-club-e0430830409524d74b29d4aee6ae9f3d.png";